import {useEffect, useState} from "react";

// Lightweight shared wishlist backed by localStorage. Every mounted consumer
// stays in sync through a module-level listener set, so the same course shows
// the same wishlist state across every rail and grid on the landing page.

const STORAGE_KEY = "fillop_wishlist";
const listeners = new Set();

let items = (() => {
  try {
    return new Set(JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]"));
  } catch {
    return new Set();
  }
})();

const commit = () => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...items]));
  } catch {
    /* storage unavailable — keep in-memory only */
  }
  const snapshot = new Set(items);
  listeners.forEach((fn) => fn(snapshot));
};

export function toggleWishlist(id) {
  if (items.has(id)) items.delete(id);
  else items.add(id);
  commit();
}

export function useWishlist() {
  const [state, setState] = useState(() => new Set(items));

  useEffect(() => {
    const fn = (next) => setState(next);
    listeners.add(fn);
    return () => listeners.delete(fn);
  }, []);

  return {
    wishlist: state,
    has: (id) => state.has(id),
    toggle: toggleWishlist,
  };
}
